export const GAME_NAME = "green-neck";

export const GAME_DURATION_SEC = 15;
export const SPACEBAR_GOAL_COUNT = 100;

export const NECK_STEP = 36;
export const NECK_INITIAL_OFFSET = -400;
export const NECK_MAX_OFFSET = -35;
export const NECK_MIN_OFFSET = -305;

export const BG_MAX_OFFSET = 10000;
export const BG_MIN_OFFSET = 0;
export const BG_STEP_PER_PRESS = 100;

export const GIRAFFE_SPACE_START = 49;

export const PARTICLE_STAGE_1_START = 51;
export const PARTICLE_STAGE_2_START = 61;
export const PARTICLE_STAGE_3_START = 71;
export const PARTICLE_LIFETIME_STEP = 0.02;
export const PARTICLE_MAX_COUNT = 50;

export const TOWER_WIDTH_RATIO = 35;
export const TOWER_HEIGHT = 12000;
export const GIRAFFE_WIDTH = 300;
export const GIRAFFE_FRAME_INTERVAL_MS = 400;

export const BG_TRANSITION_SEC = 0.1;
export const TOWER_TRANSITION_SEC = 0.1;
export const GIRAFFE_TRANSITION_SEC = 0.6;
export const SCENE_TRANSITION = "top 0.8s cubic-bezier(0.25, 1, 0.5, 1)";

export const SHAKE_DURATION_MS = 500;
export const SHAKE_TICK_MS = 16;

export const PLAYER_ID_LENGTH = 4;
export const RANKING_TOP_N = 5;
